import classNames from 'classnames';
import type { ComponentProps } from 'react';
import setDenaliAttribute from '../../utils/setDenaliAttribute';
import Avatar from '../Avatar';
import styles from './styles/styles.module.scss';

type AvatarGroupProps = {
  avatars: Pick<ComponentProps<typeof Avatar>, 'linkInfo' | 'onClick' | 'userId' | 'userName'>[];
  className?: string;
};

function AvatarGroupInternal({ avatars }: Pick<AvatarGroupProps, 'avatars'>) {
  if (avatars.length === 0) {
    // Just an error-handling case
    return <Avatar size="md" userName="" userId={0} />;
  }

  if (avatars.length === 1) {
    const { linkInfo, onClick, userId, userName } = avatars[0];
    return <Avatar linkInfo={linkInfo} onClick={onClick} userName={userName} userId={userId} size="md" stopPropagation />;
  }

  return (
    <>
      <Avatar
        linkInfo={avatars[1].linkInfo}
        onClick={avatars[1].onClick}
        userName={avatars[1].userName}
        userId={avatars[1].userId}
        size="sm"
        stopPropagation
      />
      <Avatar
        className={styles.topAvatar}
        linkInfo={avatars[0].linkInfo}
        onClick={avatars[0].onClick}
        userName={avatars[0].userName}
        userId={avatars[0].userId}
        size="sm"
        stopPropagation
        bordered
      />
    </>
  );
}

export default function AvatarGroup({ avatars, className }: Pick<AvatarGroupProps, 'avatars' | 'className'>) {
  return (
    <div {...setDenaliAttribute('AvatarGroup')} className={classNames(styles.avatarGroup, className)}>
      <AvatarGroupInternal avatars={avatars} />
    </div>
  );
}
